import React from "react";
import "./HexagonSection.css";
import hexBg from "../../../../images/landing10.png";

const HexagonSection = () => {
  return (
    <section
      className="hex-section"
      style={{
        background: `
          linear-gradient(
            rgba(30, 77, 107, 0.3),
            rgba(30, 77, 107, 0.3)
          ),
          url(${hexBg}) center/cover no-repeat
        `,
        borderRadius:"0 0 10px 10px"
      }}
    >
      <div className="hex-container">
        <div className="hex-text">
          <h2>Revolutionizing Recruitment in India</h2>
          <p>
            From Bengaluru’s tech hubs to Delhi’s enterprises, we empower
            companies with AI-powered tools, automation, and insights tailored
            to India’s dynamic talent market.
          </p>
          <button className="hex-btn">Discover More</button>
        </div>
      </div>
    </section>
  );
};

export default HexagonSection;
